<template>
  <v-container fluid style="height: 100%;padding-bottom: 125px;">
    <v-row align="center" justify="start">
      <v-col
        lg="3"
        sm="4"
        md="4"
        xs="12"
        style="padding-bottom: 0; max-height: 60px; min-width: 150px;"
      >
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="4" xs="12" sm="4" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0; min-width: 250px;"
          :color="colorTheme"
          class="white--text"
          v-on:click="newUser()"
        >
          {{ $t("addUser").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          :headers="headersSecureU"
          :items="secureUsers"
          :search="search"
          item-key="DealerId"
          :items-per-page="5"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.DealerId }}</td>
            <td class="text-xs-center">{{ props.item.DealerName }}</td>
            <td class="text-xs-center">{{ props.item.Active }}</td>
            <td class="text-xs-center">{{ props.item.JoinDate }}</td>
          </template>
          <template v-slot:item.act="{ item }">
            <v-btn
              text
              small
              :color="colorTheme"
              v-on:click="editUser(item)"
            >{{ $t("edit").toUpperCase() }}</v-btn>
            <v-btn
              text
              small
              :color="colorTheme"
              v-on:click="Confirm(item)"
            >{{ $t("delete").toUpperCase() }}</v-btn>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template
            v-slot:footer.page-text="items"
          >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="confirm" hide-overlay persistent width="315">
        <v-card>
          <v-card-title
            :color="colorTheme"
            style="font-size: 14px !important;"
          >{{ $t("deleteUser") }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding-top: 11px;">{{ rep.DealerName }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="addnew" max-width="500">
        <v-card>
          <v-card-title class="headline">{{ $t("newUser").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text style="padding-top: 28px !important;">
            <v-text-field
              solo
              :label="$t('search')"
              append-icon="mdi-magnify"
              v-model="sDealer"
              :color="colorTheme"
            ></v-text-field>
          </v-card-text>
          <v-data-table
            :no-data-text="$t('noResults')"
            v-model="selected"
            :headers="headersDealers"
            :items="dealersList"
            :search="sDealer"
            item-key="DealerId"
            show-select
            :items-per-page="5"
            class="elevation-1"
            :footer-props="{
              'items-per-page-text': $t('rows'),
              'items-per-page-all-text': $t('all')
            }"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.DealerId }}</td>
              <td class="text-xs-center">{{ props.item.Name }}</td>
              <td class="text-xs-center">{{ props.item.State }}</td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-alert"
            >{{ $t("noResults") }} : "{{ sDealer }}".</v-alert>
            <template
              v-slot:footer.page-text="items"
            >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn :color="colorTheme" text @click="addnew = false">{{ $t("cancel").toUpperCase() }}</v-btn>

            <v-btn :color="colorTheme" text @click="addUser()">{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editUserdata" max-width="500">
        <v-card>
          <v-card-title class="headline">{{ $t("editUserTitle").toUpperCase() }}</v-card-title>
          <v-progress-linear height="2" :color="colorTheme" v-model="valueDeterminate"></v-progress-linear>
          <v-card-text style="padding-top: 28px !important;">
            <v-text-field
              solo
              :label="$t('editUser')"
              append-icon="mdi-pencil"
              v-model="userData"
              :color="colorTheme"
            ></v-text-field>
            <v-switch :color="colorTheme" v-model="switch1" :label="text"></v-switch>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :color="colorTheme"
              text
              @click="editUserdata = false"
            >{{ $t("cancel").toUpperCase() }}</v-btn>

            <v-btn
              :color="colorTheme"
              text
              @click="editUserCheck()"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "reportsPage",
  components: {
    filterVehicles: () => import("@/components/filterVehicles")
  },
  data() {
    return {
      authenticated: false,
      windowSize: {
        x: 0,
        y: 0
      },
      selected: [],
      search: "",
      sDealer: "",
      confirm: false,
      addnew: false,
      sheet: true,
      editUserdata: false,
      userData: "",
      rep: {},
      switch1: true,
      text: "",
      editDealer: {}
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.dispatch("getSecureUsers");
    this.$store.commit("setTitle", this.$t("administration"));
    this.$store.commit("setPageHeader", [
      this.$t("accountM"),
      "",
      "",
      "",
      true
    ]);
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
    switch1() {
      this.text = this.switch1
        ? this.$t("active").toUpperCase()
        : this.$t("inactive").toUpperCase();
    }
  },
  computed: {
    ...mapState([
      "headersSecureU",
      "progress",
      "secureUsers",
      "valueDeterminate",
      "headersDealers",
      "dealersList",
      "colorTheme"
    ])
  },
  mounted() {},
  methods: {
    newUser: async function() {
      await this.$store.dispatch("getFilterAccountCatalog", [
        "dealers",
        "Master"
      ]);
      this.addnew = true;
    },
    addUser: async function() {
      if (this.selected.length > 0) {
        await this.$store.dispatch("addSecureUser", this.selected);
        this.addnew = false;
        this.$store.dispatch("getSecureUsers");
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("userSelect")
        });
      }
    },
    editUser: async function(item) {
      this.editDealer = JSON.parse(JSON.stringify(item));
      this.editUserdata = true;
      this.switch1 =
        item.Active == this.$t("active").toUpperCase() ? true : false;
      this.userData = item.DealerName;
      this.text = this.switch1
        ? this.$t("active").toUpperCase()
        : this.$t("inactive").toUpperCase();
    },
    editUserCheck: async function() {
      this.editUserdata = false;
      this.editDealer.Active = this.switch1;
      this.editDealer.DealerName = this.userData;
      await this.$store.dispatch("editSecureUser", this.editDealer);
    },
    toggleAll() {
      var array = this.$store.state.dealersList;
      if (this.selected.length) this.selected = [];
      else this.selected = array.slice();
    },
    confirmation: function(val) {
      if (val) {
        this.$store.dispatch("delecteSecureUser", this.rep.Id);
      }
    },
    Confirm(report) {
      this.rep = report;
      this.confirm = true;
    },
    setAccount() {
      //store state selected accces
    }
  }
};
</script>
